var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBtnResetFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 12"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m15.106 4.303-1.687 2.446-2.396-1.71.62-.868 1.513 1.08 1.072-1.554zM2.569 5.251l2.406 1.71-.618.869-1.521-1.08L1.773 8.3.893 7.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.13 11.867C4.833 11.867 2.134 9.25 2.134 6h1.066c0 2.637 2.198 4.8 4.932 4.8 1.365 0 2.6-.54 3.498-1.408l.74.768a6.1 6.1 0 0 1-4.238 1.707M3.629 1.84A6.1 6.1 0 0 1 7.869.133c3.298 0 5.997 2.616 5.997 5.867h-1.067c0-2.637-2.197-4.8-4.93-4.8-1.366 0-2.6.54-3.5 1.408z"
}))));
export default SvgBtnResetFilter;